import styled from "styled-components";
import MenuItem from "@material-ui/core/MenuItem";
import { IconButton } from "@material-ui/core";

export const MenuItemName = styled(MenuItem)`
   padding: 5px;
   letter-spacing: 0;
   margin: 0;
   min-height: 0 !important;
`;
export const MenuSpan = styled.span`
    opacity: 0.65 !important;
    pointer-events: none;
    height: auto;
    display: block;
    border: none;
    border-bottom: 1px solid rgba(0,0,0,.12);
`;
export const MenuIcon = styled(IconButton)`
   margin-right: 20px !important;
   background-color: rgb(239, 239, 239) !important;
   padding: 8px !important;
`;